module.exports = __webpack_public_path__ + "img/folder.5a9e96d5.webp";